<template>
  <v-chart
    class="lifecycle-chart"
    :options="chartOptions"
    autoresize
    @click="handleChartClick"
  />
</template>

<script>
import {
  DataZoomComponent,
  GridComponent,
  LegendComponent,
  TooltipComponent,
} from "echarts/components";
import {
  LIGHT_GREEN,
  LIGHT_RED,
  PRIMARY_FONT_BLUE,
} from "../../utils/constants";
import { BarChart } from "echarts/charts";
import ECharts from "vue-echarts";
import { formatDateToCommon } from "../../utils/helper";
import { use } from "echarts/core";

use([
  TooltipComponent,
  GridComponent,
  LegendComponent,
  DataZoomComponent,
  BarChart,
]);

export default {
  name: "time-versions-chart",
  components: { "v-chart": ECharts },
  props: {
    data: Array,
  },
  data() {
    return {
      chartOptions: {
        dataZoom: [
          {
            type: "inside",
          },
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          valueFormatter: (val) => `${(val * 100).toFixed(2)} %`,
        },
        grid: [
          {
            left: 50,
            width: "absolute",
            right: 25,
            show: true,
            borderWidth: 0,
            height: "auto",
            bottom: 25,
          },
        ],
        xAxis: [
          {
            type: "category",
            data: [],
            axisLabel: {
              color: (val, i) =>
                this.data[i].rebalance ? PRIMARY_FONT_BLUE : "#000000",
              fontWeight: (val, i) =>
                this.data[i].rebalance ? "bold" : "normal",
              formatter: (val, i) => (this.data[i].rebalance ? `${val}*` : val),
              fontSize: 10,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              formatter: (val) => `${val * 100} %`,
            },
          },
        ],
        series: [
          {
            type: "bar",
            data: [],
            color: LIGHT_GREEN,
            name: "Expected return",
          },
          {
            type: "bar",
            data: [],
            color: LIGHT_RED,
            name: "Volatility",
          },
        ],
      },
    };
  },
  methods: {
    populateData() {
      const cop = this.chartOptions;
      cop.xAxis[0].data = this.data.map((obj) => formatDateToCommon(obj.date));
      cop.series[0].data = this.data.map(
        (obj) => obj.custom_portfolio_output.expected_return
      );
      cop.series[1].data = this.data.map(
        (obj) => obj.custom_portfolio_output.volatility
      );
    },
    handleChartClick(item) {
      this.$emit("chartClick", this.data[item.dataIndex].history_id);
    },
  },
  mounted() {
    this.populateData();
  },
  watch: {
    data() {
      this.populateData();
    },
  },
};
</script>

<style>
</style>